
const HEALTH_VALIDATION = "health-validation";
const VALIDATE_HEALTH = "health";
const VALIDATE_CONFIG = "config";

export class EpDevPHealthValidationApiRoutesFactory {

  public static getSubRouteBase = (): string => {
    return `/${HEALTH_VALIDATION}`;
  }
  public static getSubRouteValidateHealth = (): string => { 
    return `${EpDevPHealthValidationApiRoutesFactory.getSubRouteBase()}/${VALIDATE_HEALTH}`;
  }
  public static getSubRouteValidateConfig = (): string => { 
    return `${EpDevPHealthValidationApiRoutesFactory.getSubRouteBase()}/${VALIDATE_CONFIG}`;
  }
}

export class EpDevPHealthValidationApiPathsFactory {

  public static createValidateHealthPath(): string {
    return `/${HEALTH_VALIDATION}/${VALIDATE_HEALTH}`;
  }

  public static createValidateConfigPath(): string {
    return `/${HEALTH_VALIDATION}/${VALIDATE_CONFIG}`;
  }

}
